var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutoGeneratedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50488 4.83984C3.57625 4.38903 4.22509 4.38959 4.2959 4.83984C4.41943 5.62585 4.83039 6.33778 5.44922 6.83789C5.80394 7.12463 5.47946 7.68701 5.05371 7.52344C4.31132 7.23759 3.48946 7.23759 2.74707 7.52344C2.32092 7.68746 1.99675 7.1247 2.35156 6.83789C2.97022 6.33779 3.38137 5.62572 3.50488 4.83984ZM3.8125 5.92676L3.46875 6.52441L3.38281 6.6748H4.41895L3.89941 5.77637L3.8125 5.92676Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58496 6.83203C5.60605 6.85665 5.62457 6.88184 5.63965 6.9082L5.67676 6.99023C5.65797 6.93488 5.62741 6.88156 5.58496 6.83203Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69336 0C4.90295 5.1211e-05 5.10625 0.0743875 5.26758 0.208008L5.33301 0.266602L7.53711 2.4707C7.6491 2.5827 7.72876 2.72188 7.76953 2.87305L7.79688 3.02832L7.80078 3.1123V8.90039C7.80085 9.1274 7.71488 9.34622 7.56055 9.5127C7.40616 9.67919 7.19419 9.78082 6.96777 9.79785L6.89746 9.80078H0.900391C0.673377 9.80085 0.454565 9.71488 0.288086 9.56055C0.142332 9.42539 0.0458528 9.24617 0.0126954 9.05176L0.00292973 8.96777L4.49872e-08 8.89746V0.900391C-7.17963e-05 0.673377 0.0859023 0.454565 0.240234 0.288086C0.394442 0.121792 0.605915 0.0191635 0.832031 0.00195312L0.90332 0H4.69336ZM0.800781 0.800781V9H7V3.80078H4.65039C4.48898 3.80077 4.33343 3.74025 4.21387 3.63184C4.12425 3.55044 4.0596 3.44585 4.02637 3.33105L4.00391 3.21289L4 3.14551V0.800781H0.800781ZM4.80078 3H6.93457L6.76367 2.83008L4.9707 1.03711L4.80078 0.866211V3Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoGeneratedIcon);
export default __webpack_public_path__ + "static/media/auto-generated-icon.177a5b5edfb1d4b1b7c40d61dc891722.svg";
export { ForwardRef as ReactComponent };